import { useQuery } from "react-query";
import SkillsReportsService from "./SkillsReportsService";

const useSearchUsersBySkill = (skillName) => {
  return useQuery(
    ["searchUsersBySkill", skillName],
    () => SkillsReportsService.searchUserSkill(skillName).then((res) => res.data),
    {
      enabled: !!skillName,
    }
  );
};

export default useSearchUsersBySkill;
